import styled from 'styled-components';

import { WithLink } from 'components/ToolkitV2/CardV2/enhancements/WithLink/WithLink';
import { Card } from 'components/ToolkitV2/CardV2/Card';

import { media } from 'helpers/breakpoints';

const SimilarAdLink = styled(WithLink)<{ hide?: boolean }>`
  display: ${({ hide }) => (hide ? 'none' : 'block')};

  ${media.medium} {
    display: block;
  }
`;

const SimilarAdCard = styled(Card)`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};
  height: 100%;
  overflow: hidden;
`;

const Header = styled.span`
  ${({ theme }) => theme.fontSize.B12};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 124px;

  ${media.medium} {
    ${({ theme }) => theme.fontSize.M16};
    max-width: 178px;
  }
`;

export { SimilarAdLink, SimilarAdCard, Header };
